/**
 * Константы для работы с API
 */

// Базовый URL API
export const API_BASE_URL = '/api'; // Используем правильный префикс для API

// URL файлового сервиса
export const FILE_SERVICE_URL = ''; // Используем пустой URL, чтобы запросы шли относительно текущего хоста

// Таймаут для API-запросов (в миллисекундах)
export const API_TIMEOUT = 30000;

// Количество элементов на странице по умолчанию
export const DEFAULT_PAGE_SIZE = 20;

// Другие настройки
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB 